/* eslint-disable */
// This file is auto-generated by scripts/sync-languages.js
// Do not edit this file manually.

import translationAR from '../assets/locales/ar/translation.json';
import translationEN from '../assets/locales/en/translation.json';
import translationES from '../assets/locales/es/translation.json';
import translationIT from '../assets/locales/it/translation.json';
import translationPT from '../assets/locales/pt/translation.json';
import translationTR from '../assets/locales/tr/translation.json';
import translationZH from '../assets/locales/zh/translation.json';

export const languageAssets = {
  'ar': translationAR,
  'en': translationEN,
  'es': translationES,
  'it': translationIT,
  'pt': translationPT,
  'tr': translationTR,
  'zh': translationZH,
};

export const languageCodes = [
  "ar",
  "en",
  "es",
  "it",
  "pt",
  "tr",
  "zh"
];
